import { createSelector } from 'reselect';
import { JsonObj } from '@mhp/general-interface';
import orderBy from 'lodash/orderBy';
import { RootState } from 'store/types';
import { Consumer } from 'store/profile/types';
import { currentAccountConsumerSelector } from 'store/account/selectors';

const filterByConsumerId = <T extends JsonObj>(data: T[], consumer: Consumer) => {
  if (!consumer) {
    return data;
  }

  return data.filter(d => d.consumerId === consumer.consumerId);
};

export const upcomingAppointmentsSelector = (state: RootState) =>
  state.booking.appointments.upcoming;

export const upcomingAppointmentsFetchingSelector = createSelector(
  upcomingAppointmentsSelector,
  upcoming => upcoming.isFetching
);

export const upcomingAppointmentsErrorSelector = createSelector(
  upcomingAppointmentsSelector,
  upcoming => upcoming.error
);

export const upcomingAppointmentsDataSelector = createSelector(
  upcomingAppointmentsSelector,
  upcoming => upcoming.data
);

export const upcomingAppointmentsRequestStateSelector = createSelector(
  upcomingAppointmentsSelector,
  upcoming => upcoming.requestState
);

export const upcomingAppointmentForConsumerSelector = createSelector(
  [upcomingAppointmentsDataSelector, currentAccountConsumerSelector],
  (appts, account) => orderBy(filterByConsumerId(appts, account), ['appointmentDate'], ['asc'])
);

export const searchFormattedAppointments = createSelector(
  upcomingAppointmentForConsumerSelector,
  data => {
    return data.map(item => {
      return {
        title: item?.appointmentReasonDesc,
        provider: item?.providerDisplayName,
        location: item?.locationDisplay,
        date: item?.appointmentDate,
        category: 'appointments',
        icon: 'CalendarFlat',
        keywords: ['appointment', 'upcoming', 'appointments'],
        data: item,
        navWebPath: `/u/get-care-now`,
        navParams: { expandAppointments: true, openById: item?.appointmentId }
      };
    });
  }
);
